import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const NAV_OFFSET = 80;

const ScrollManager = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const targetId = decodeURIComponent(location.hash.replace("#", ""));

      const scrollToTarget = () => {
        const el = document.getElementById(targetId);
        if (!el) return;
        const y = el.getBoundingClientRect().top + window.scrollY - NAV_OFFSET;
        window.scrollTo({ top: y, left: 0, behavior: "auto" });
      };

      // Repeat scrolls to account for layout shifts from images/animations.
      const timers = [0, 100, 300, 600, 1000].map((delay) =>
        window.setTimeout(scrollToTarget, delay),
      );

      return () => timers.forEach((t) => window.clearTimeout(t));
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.hash]);

  return null;
};

export default ScrollManager;
